import React, { useState } from 'react';
import './App.css';
import NavBar from './components/NavBar';
import ConnectionsGame from './components/ConnectionsGame';
import MiniCrossword from './components/MiniCrossword';

function App() {
  const [activeGame, setActiveGame] = useState('connections');

  return (
    <div className="App">
      <NavBar activeGame={activeGame} onGameChange={setActiveGame} />
      <main className="app-main">
        {activeGame === 'connections' && <ConnectionsGame />}
        {activeGame === 'crossword' && <MiniCrossword />}
      </main>
    </div>
  );
}

export default App;
